module.exports = "pegasus_template/assets/theme2/header-image.jpg";